import { render, staticRenderFns } from "./practice-solid.vue?vue&type=template&id=023d71cc"
import script from "./practice-solid.vue?vue&type=script&lang=js"
export * from "./practice-solid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports